import * as React from "react";
import { AudioWaveform, Command, GalleryVerticalEnd } from "lucide-react";

import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import { TeamSwitcher } from "@/components/team-switcher";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar";
import { getAuthTokenData } from "utils/tokenUtils";
import { sideBarRoutes } from "constants/routes";

const data = {
	name: "Watcher Inc",
	logo: GalleryVerticalEnd,
	plan: "Enterprise",
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const [user, setUser] = React.useState<any>({});
	React.useEffect(() => {
		const { userId, name, role, email } = getAuthTokenData();
		setUser({ userId, name, role, email });
	}, []);

	const filteredRoutes = sideBarRoutes.filter((route) => route.roles.includes(user.role || ""));

	return (
		<Sidebar collapsible="icon" {...props}>
			<SidebarHeader>
				<TeamSwitcher teams={data} />
			</SidebarHeader>
			<SidebarContent>
				<NavMain items={filteredRoutes} />
			</SidebarContent>
			<SidebarFooter>
				<NavUser user={user} />
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	);
}
